import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AccountLayout from "../components/AccountLayout";
import {
  LuClipboardList,
  LuSettings,
  LuMapPin,
  LuShield,
  LuArrowRight,
} from "react-icons/lu";

const CARDS = [
  {
    to: "/orders",           label: "My Orders",           desc: "Track and view all your past wholesale orders.",         Icon: LuClipboardList, cta: "View Orders",
  },
  {
    to: "/account/settings", label: "Account Settings",    desc: "Update your display name, email, and contact info.",    Icon: LuSettings,      cta: "Edit Settings",
  },
  {
    to: "/shipping-address", label: "Shipping Addresses",  desc: "Manage saved delivery addresses for your business.",     Icon: LuMapPin,        cta: "Manage Addresses",
  },
  {
    to: "/account/security", label: "Security",            desc: "Change your password or send a password reset email.",  Icon: LuShield,        cta: "Security Settings",
  },
];

export default function Dashboard() {
  const { user } = useAuth();

  return (
    <AccountLayout title={`Welcome back, ${user?.displayName || user?.email?.split("@")[0] || "there"}`}>
      <p className="text-[var(--color-muted-foreground)] text-sm -mt-4 mb-8">Here's an overview of your wholesale account.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        {CARDS.map(({ to, label, desc, Icon, cta }) => (
          <div key={to} className="bg-card rounded-2xl border border-border shadow-sm p-6 flex flex-col gap-4 hover:shadow-md transition-shadow">
            <div className="w-12 h-12 rounded-2xl bg-brand-navy flex items-center justify-center">
              <Icon size={20} className="text-brand-amber" />
            </div>
            <div>
              <h3 className="font-bold text-foreground text-base mb-1">{label}</h3>
              <p className="text-[var(--color-muted-foreground)] text-sm leading-relaxed">{desc}</p>
            </div>
            <Link to={to} className="mt-auto flex items-center gap-1.5 text-accent font-bold text-sm hover:gap-3 transition-all">
              {cta}
              <LuArrowRight size={16} />
            </Link>
          </div>
        ))}
      </div>
    </AccountLayout>
  );
}
